var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6666 8C27.403 8 27.9999 8.59695 27.9999 9.33333V22.6667C27.9999 23.403 27.403 24 26.6666 24H11.9999L5.33326 17.3333C4.65421 16.5741 4.65421 15.4259 5.33326 14.6667L11.9999 8H26.6666Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6187 12.7146C16.277 12.3729 15.723 12.3729 15.3813 12.7146C15.0396 13.0563 15.0396 13.6103 15.3813 13.952L16.6187 12.7146ZM20.7146 19.2854C21.0563 19.6271 21.6103 19.6271 21.9521 19.2854C22.2938 18.9437 22.2938 18.3896 21.9521 18.0479L20.7146 19.2854ZM21.9521 13.952C22.2938 13.6103 22.2938 13.0563 21.9521 12.7146C21.6103 12.3729 21.0563 12.3729 20.7146 12.7146L21.9521 13.952ZM15.3813 18.0479C15.0396 18.3896 15.0396 18.9437 15.3813 19.2854C15.723 19.6271 16.277 19.6271 16.6187 19.2854L15.3813 18.0479ZM15.3813 13.952L20.7146 19.2854L21.9521 18.0479L16.6187 12.7146L15.3813 13.952ZM20.7146 12.7146L15.3813 18.0479L16.6187 19.2854L21.9521 13.952L20.7146 12.7146Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.ebba1eaf384d27314f2d97bef4852a21.svg";
export { ForwardRef as ReactComponent };